import Vue from "vue";
import Component from "vue-class-component";

@Component
export class PreventKey extends Vue {
  preventKey(e: KeyboardEvent) {
    const keysToPrevent = ["e", "+"];
    if (keysToPrevent.includes(e.key)) e.preventDefault();
  }

  avoidKey(e: KeyboardEvent) {
    const keysToPrevent = ["e", "+", "-", ",", "."];
    if (keysToPrevent.includes(e.key)) e.preventDefault();
  }
}
